import { createSelector } from 'reselect'
import lessonTypes from 'helpers/enums/lessonTypes'

const lessonsData = state => state.lessons
const getMediaSlidesData = state => state.mediaSlides
const storeLessonsData = state => state.store.results

const storeLessonsIdWithoutData = createSelector(
	[ getMediaSlidesData, storeLessonsData, lessonsData ],
	(mediaSlides, storeLessons, lessons) => {
		const lessonsIdWithoutData = storeLessons.filter(lessonUid =>
			lessons[lessonUid].data.type === lessonTypes.VIDEO &&
			mediaSlides.findIndex(mediaSlide => mediaSlide.lessonUid === lessonUid) === -1
		)
		return ({
			lessonsIdWithoutData,
		})
	}
)

export default storeLessonsIdWithoutData
